import { Component, OnInit, OnChanges, Input, Output, ViewChild, EventEmitter } from '@angular/core';
import { DxDataGridComponent } from "devextreme-angular";
import { custom } from 'devextreme/ui/dialog';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from 'devextreme/data/array_store';
import { LanguageService } from '../../../../../../../shared/services/language.service';
import { TimeService } from '../../../../../_api/services/time.service';
import { AmsNotifierService } from '../../../../../../../shared/services/ams-notifier.service';

@Component({
  selector: 'app-edit-transport-expense',
  templateUrl: './edit-transport-expense.component.html',
  styleUrls: ['./edit-transport-expense.component.css']
})
export class EditTransportExpenseComponent implements OnInit, OnChanges {
  @ViewChild('datagriddx', {static:false}) dataGrid: DxDataGridComponent;
  @Input() gridDataSource: any;
  expenseTypeDataSource: any;
  @Output() loading = new EventEmitter<boolean>();//emit event to parent(project-portal.component) to show load indicator
  @Input() transport: any;
  @Input() newStatusId: number = 3;//Eirik 02.12.19 task 154 - status when inserting time posts
  @Input() newCategoryId: number = 8;//Eirik 02.12.19 task 154 - category when inserting time posts
  @Output() changed = new EventEmitter();
  isEditingDisabled = false;
  expenseTypes: any; 
  validateExpenseTypeMessage = this.languageService.LNG("Please.Select.Expensetype"); 

  newExpense: any = { ExpenseTypeId: -1, Value: null }

  constructor(public languageService: LanguageService, private timeService: TimeService, private amsNotifierService: AmsNotifierService) { }

  ngOnInit() {
    this.timeService.getExpenseTypes()
      .subscribe((result: any) => {
        this.expenseTypes = result.Data; 
        this.expenseTypeDataSource = new DataSource({
          store: new ArrayStore({
              data: result.Data,
              key: "ExpenseTypeId",
          }),
          group: "ExpenseTypeCategoryCode"
        });
      }, error => { 
    });
  }

  ngOnChanges() {
    this.isEditingDisabled = this.transport.TransportStatusId >= 4;
  }

  onExpenseTypeChanged(e, cell) {
    let sel = e.component.option("selectedItem");
    if (sel) {
      let data = {
        ExpenseTypeId: sel.ExpenseTypeId,
        Code: sel.Code,
        UnitId: sel.UnitId,
        UnitCode: sel.UnitCode
      }
      cell.setValue(data);
    }
    else {
      cell.setValue(null);
    }
  }

  setExpenseTypeValue(newData, value) {
    newData.ExpenseTypeId = value.ExpenseTypeId;
    newData.Code = value.Code;
    newData.UnitId = value.UnitId;
    newData.UnitCode = value.UnitCode;
  }

  onEditorPreparing(e) {
    if(e.parentType == "dataRow"){

      e.editorOptions.onFocusIn = function(args) {
        const input = args.element.querySelector('.dx-texteditor-input');
        if (input !== null && input !== undefined) {
          input.select();
        }
      }
   }
  }

  createNewExpense() {
    this.loading.emit(true);
    let expense = {
      ExpenseId: -1,
      ExpenseTypeId: this.newExpense.ExpenseTypeId,
      Value: this.newExpense.Value,
      CarrierId: this.transport.CarrierId,
      EmployeeId: this.transport.EmployeeId,
      Date: this.transport.Date,
      CategoryId: this.newCategoryId,
      StatusId: this.newStatusId,
    };

    if(this.isValid()) {
      this.timeService.insertExpense(expense)
        .subscribe((result: any) => { 

          if (result.IsSuccess) {
            this.amsNotifierService.success(this.languageService.LNG("Label.SavedOK"));
            if (result.Message != null && result.Message.length > 0) {
              this.amsNotifierService.error(result.Message);
            }
            this.newExpense = { ExpenseTypeId: -1, Value: null }
            this.refresh();
          }
          else {
            this.loading.emit(false);
            this.amsNotifierService.error(result.ErrorMessage);
          }
        }, error => { 
          this.loading.emit(false);
      });
    }
    this.loading.emit(false); 
  }

  isValid(): boolean {
    let isValid: boolean = true; 
    
    if (this.newExpense.ExpenseTypeId < 0) {
      this.amsNotifierService.error(this.validateExpenseTypeMessage);
      isValid = false; 
    }

    return isValid; 
  }

  refresh() {
    this.loading.emit(true);
    this.timeService.getExpensesByTransportCollection(this.transport.TransportCollectionId)
      .subscribe((result: any) => { // success path

        this.loading.emit(false);
        if (result.IsSuccess) {
          this.gridDataSource = result.Data;
          this.changed.emit();
        }
        else {
          this.amsNotifierService.error(result.ErrorMessage);
        }
      }, error => { // error path;
        this.loading.emit(false);
      });
  }

  onRowUpdating(e) {
    const isCanceled = new Promise((resolve) => {
      this.loading.emit(true);
      for (var property in e.oldData) {
        if (!e.newData.hasOwnProperty(property)) {
          e.newData[property] = e.oldData[property];
        }
      }
      let expense = {
        ExpenseId: e.newData.ExpenseId,
        ExpenseTypeId: e.newData.ExpenseTypeId,
        Value: e.newData.Value,
        CarrierId: this.transport.CarrierId,
        EmployeeId: this.transport.EmployeeId,
        Date: this.transport.Date,
        CategoryId: 8,//transportcollection
      };

      this.timeService.updateExpense(expense)
        .subscribe((result: any) => { 
          this.loading.emit(false);
          if (result.IsSuccess) {
            resolve(false);
            this.amsNotifierService.success(this.languageService.LNG("Label.SavedOK"));
            if (result.Message != null && result.Message.length > 0) {
              this.amsNotifierService.error(result.Message);
            }
            e.component.cancelEditData();
            this.refresh();
          }
          else {
            this.loading.emit(false);
            resolve(true);
            this.amsNotifierService.error(result.ErrorMessage);
          }
        }, error => { 
          this.loading.emit(false);
          resolve(true);
        });
    });
    e.cancel = isCanceled;
  }

  onRowRemoving(e: any) {
    let expenseIds: number[] = [];
    expenseIds.push(e.data.ExpenseId)
    this.loading.emit(true);
    
    this.timeService.deleteExpenseByExpenseIds(expenseIds).subscribe((result: any) => { 
      this.amsNotifierService.success(this.languageService.LNG("Label.DeletedOK"));
      if (result.Message != null && result.Message.length > 0) {
        this.amsNotifierService.error(result.Message);
      }
      this.loading.emit(false);
      this.refresh();
      this.dataGrid.selectedRowKeys = [];
    }, error => {
      this.loading.emit(false);
    });
  }

}
